import React from 'react';
import { TranslatedBadgeRectangle } from './TranslatedBadgeRectangle';

function GiftCard(props) {
    return (
        <TranslatedBadgeRectangle {...props} />
    );
}

export default GiftCard;
